<template>
  <div>
    <VacancyDetailPage v-if="isDetailPage" />
    <VacanciesPage v-else />
  </div>
</template>

<script setup>
  import { VacancyDetailPage, VacanciesPage } from '~/components/vacancies/index.ts'

  const route = useRoute()
  const slug = computed(() => route.params.slug)

  const isDetailPage = computed(() => {
    return slug.value?.length === 1 && /^\d+$/.test(slug.value[0])
  })
</script>
